const selector = {
    btnViewTransactions: '.js-view-transactions',
    modalTransactions: '#modal_transactions',
    transactionsLoader: '#transactions_loader',
    transactionsContent: '#transactions_content',
    transactionsEmpty: '#transactions_empty',
    transactionsError: '#transactions_error',

    balanceAmount: '.js-balance-amount',
    tagBalance: '.js-tag-balance',
    modalTransfer: '#modal_transfer',
    transferForm: '#transfer_form',
    transferMessage: '#transfer_message',
    transferTag: '.js-transfer-tag',
    transferAmount: '.js-transfer-amount',
    transferAll: '.js-transfer-all',
    transferSubmit: '.js-transfer-submit',
};

export { selector };
